import { render, staticRenderFns } from "./SignupHeroes.vue?vue&type=template&id=15cc4e69&scoped=true&"
import script from "./SignupHeroes.vue?vue&type=script&lang=js&"
export * from "./SignupHeroes.vue?vue&type=script&lang=js&"
import style0 from "./SignupHeroes.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SignupHeroes.vue?vue&type=style&index=1&id=15cc4e69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cc4e69",
  null
  
)

export default component.exports